<div class="ms-3 mb-2" [ngClass]="inTable? 'mt-0':'mt-3'"
  [style.display]="this.calendarElem.enabled === undefined || activeElements[this.calendarElem?.enabled] ? 'block' : 'none'">
  @if (!inTable) {
    <label style="font-weight: 600;">{{ calendarElem.title }}</label>
  }
  <form class="form-inline">
    <div class="form-group">
      <div class="input-group">
        <input class="form-control" placeholder="yyyy-mm-dd" style="max-width: 130px;"
          name="dp" [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker"
          (ngModelChange)="onChange()">
          <button class="btn btn-outline-secondary calendar-contrl" (click)="d.toggle()" type="button"></button>
        </div>
      </div>
    </form>
  </div>
